"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.set_animation_tooltips = exports.nodeTooltipsContent = exports.linkTooltipsContent = void 0;
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const d3 = __importStar(require("d3"));
const linkTooltipsContent = (data, l) => {
    const { tooltip_names, units_names } = data;
    let t = '<p style=\'text-align: center;margin-bottom:0px\'><b>' + data.nodes[l.idSource].name.split('\\n').join(' ') + ' -> ' + data.nodes[l.idTarget].name.split('\\n').join(' ') + '</b></p>';
    if (l.tooltip_text) {
        //t += '<p><b>Définition'+ '</b></p>' 
        t += '<p>' + l.tooltip_text.split('\n').join('</br>') + '</p>';
    }
    let default_unit_name = '';
    let unit_coeff = ' ';
    if (units_names && units_names[0] && units_names[0].length > 0) {
        default_unit_name = units_names[0][0];
        if (data.units_names[0][0].includes('k ')) {
            unit_coeff = ' k ';
        }
    }
    //- Données
    let children = false;
    let desagregate_source_nodes = [];
    let desagregate_target_nodes = [];
    //if ('flux_types' in l.tags && l.tags['flux_types'].includes('initial_data') && l.data_value && (l.data_value as number[])[value_index] !== -1) {
    const link_info = SankeyUtils_1.getLinkValue(data, l.idLink);
    if (link_info.extension.data_value) {
        t += '<p>Donnée collectée </p>';
        t += '<table class="table table-striped " >';
        t += '<thead><tr>';
        if (units_names && units_names[0]) {
            t += '<th>' + default_unit_name + '</th>';
            if (l.conv) {
                t += '<th>' + unit_coeff + String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't') + '</th>';
            }
        }
        else {
            t += '<th>Valeur</th>';
        }
        if (link_info.extension.data_source) {
            t += '<th>Source</th>';
        }
        if (link_info.extension.data_period) {
            t += '<th>Période</th>';
        }
        t += '</tr><tbody><tr>';
        t += '<td>' + SankeyUtils_1.toPrecision(+link_info.extension.data_value) + '</td>';
        if (l.conv) {
            t += '<td>' + SankeyUtils_1.toPrecision(link_info.extension.data_value * l.conv[1]) + '</td>';
        }
        if (link_info.extension.data_source) {
            t += '<td>' + link_info.extension.data_source + '</td>';
        }
        if (link_info.extension.data_period) {
            t += '<td>' + link_info.extension.data_period + '</td>';
        }
        t += '</tr></tbody></table>';
    }
    else if (link_info.extension.data_min) {
        t += '<p>Bornes collectées </p>';
        t += '<table class="table table-striped " >';
        t += '<thead><tr>';
        // if (units_names && units_names[0] ) {
        //   t +=      '<th>'+default_unit_name+'</th>'
        //   if ( l.conv  ) {
        //     t +=    '<th>'+String(l.natural_unit).replace('tonnes','t').replace('tonne','t')+'</th>'
        //   }
        // } else {
        t += '<th>Minimum</th><th>Maximum</th>';
        //}
        if (link_info.extension.data_source) {
            t += '<th>Source</th>';
        }
        if (link_info.extension.data_period) {
            t += '<th>Période</th>';
        }
        t += '</tr><tbody><tr>';
        t += '<td>' + link_info.extension.data_min + '</td>';
        t += '<td>' + link_info.extension.data_max + '</td>';
        // if ( l.conv  ) {
        //   t += '<td>' + toPrecision(link_info.extension.data_value*l.conv[1] ) + '</td>'
        // }  
        if (link_info.extension.data_source) {
            t += '<td>' + link_info.extension.data_source + '</td>';
        }
        if (link_info.extension.data_period) {
            t += '<td>' + link_info.extension.data_period + '</td>';
        }
        t += '</tr></tbody></table>';
    }
    else {
        const source_node = data.nodes[l.idSource];
        const target_node = data.nodes[l.idTarget];
        desagregate_source_nodes = Object.values(data.nodes).filter(n => {
            for (const dim in n.dimensions) {
                if (data.nodeTags[dim].activated === false) {
                    continue;
                }
                if (n.dimensions[dim] !== undefined && n.dimensions[dim].parent_name) {
                    if (n.dimensions[dim].parent_name === source_node.idNode) {
                        return true;
                    }
                    else {
                        const parent_node = Object.values(data.nodes).filter(n2 => n.dimensions[dim].parent_name && (n2.idNode === n.dimensions[dim].parent_name))[0];
                        if (parent_node && parent_node.dimensions[dim] && parent_node.dimensions[dim].parent_name === source_node.idNode) {
                            return true;
                        }
                    }
                }
                return false;
            }
        });
        desagregate_target_nodes = Object.values(data.nodes).filter(n => {
            for (const dim in n.dimensions) {
                if (data.nodeTags[dim].activated === false) {
                    continue;
                }
                if (n.dimensions[dim] !== undefined && n.dimensions[dim].parent_name) {
                    const parent_name = n.dimensions[dim].parent_name;
                    if (parent_name === target_node.idNode) {
                        return true;
                    }
                    else {
                        const parent_node = Object.values(data.nodes).filter(n2 => n2.idNode === parent_name)[0];
                        if (parent_node && parent_node.dimensions[dim] && parent_node.dimensions[dim].parent_name === target_node.idNode) {
                            return true;
                        }
                    }
                }
            }
            return false;
        });
        children = desagregate_source_nodes.length > 0 || desagregate_target_nodes.length > 0;
        desagregate_target_nodes.push(target_node);
        desagregate_source_nodes.push(source_node);
        t = write_children_table(desagregate_source_nodes, desagregate_target_nodes, data, t, default_unit_name, l, true);
    }
    // } else if (l.data_constraint) {
    //   t += '<b>Contraintes du modéle: % de  '+ l.source_name.split('\\n').join(' ') + '</b><ul style=\'margin-bottom:0px\'>'
    //   for (const constraint in l.data_constraint) {
    //     t += '<li>' + l.data_constraint[constraint] + '</li>'            
    //   }
    // }
    // const unit_name = units_names && units_names.length != 0 ? default_unit_name : ''
    // Variables non libres
    if (link_info.extension.free_mini === undefined) {
        if (link_info.extension.data_value) {
            if (children) {
                t = write_children_table(desagregate_source_nodes, desagregate_target_nodes, data, t, default_unit_name, l, false);
            }
            t += '<p>Donnée réconciliée :</p>';
        }
        else {
            t += '<p>Donnée déterminée :</p>';
        }
        t += '<table class="table table-striped " >';
        if (units_names && units_names[0]) {
            t += '<thead><tr><th>Unités</th>';
            t += '<th>' + default_unit_name.replace('tonnes', 't').replace('tonne', 't') + '</th>';
            if (l.conv) {
                t += '<th>' + unit_coeff + String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't') + '</th>';
            }
            if (units_names !== undefined) {
                for (let i = 2; i < units_names.length; i++) {
                    if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                        continue;
                    }
                    if (l.conv && l.conv[i] !== null) {
                        t += '<th>' + unit_coeff + units_names[i][0].replace('tonnes', 't').replace('tonne', 't') + '</th>';
                    }
                }
            }
            t += '</tr></thead>';
        }
        t += '<tbody><tr><th>Valeur</th>';
        let the_value = +link_info.value;
        if (link_info.display_value !== '') {
            the_value = Number(String(link_info.display_value).replace('*', ''));
        }
        t += '<td>' + SankeyUtils_1.toPrecision(the_value) + '</td>';
        t += '</td>';
        if (l.conv) {
            if (l.natural_unit) {
                t += '<td>' + SankeyUtils_1.toPrecision(the_value * l.conv[1]);
                t += '</td>';
            }
            for (let i = 2; i < units_names.length; i++) {
                if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                    continue;
                }
                if (l.conv[i] !== null) {
                    t += '<td>' + SankeyUtils_1.toPrecision(the_value * l.conv[i]);
                    t += '</td>';
                }
            }
        }
        t += '</tr>';
        const interval = link_info.extension.mini !== undefined && link_info.extension.maxi !== undefined && link_info.extension.mini !== null && link_info.extension.maxi !== null && link_info.extension.mini !== link_info.extension.maxi ? [link_info.extension.mini, link_info.extension.maxi] : undefined;
        if (interval) {
            t += '<tr><th>Bornes d\'incertitudes</th>' + '<td>' + SankeyUtils_1.toPrecision(interval[0]) + ' - ' + SankeyUtils_1.toPrecision(interval[1]) + '</td>';
            if (l.conv) {
                if (l.natural_unit) {
                    t += '<td>';
                    t += SankeyUtils_1.toPrecision(interval[0] * l.conv[1]) + ' - ' + SankeyUtils_1.toPrecision(interval[1] * l.conv[1]);
                    t += '</td>';
                }
                for (let i = 2; i < units_names.length; i++) {
                    if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                        continue;
                    }
                    if (l.conv[i] !== null) {
                        t += '<td>';
                        t += SankeyUtils_1.toPrecision(interval[0] * l.conv[i]) + ' - ' + SankeyUtils_1.toPrecision(interval[1] * l.conv[i]);
                        t += '</td>';
                    }
                }
            }
        }
        Object.entries(data.fluxTags).forEach(tag => t += '<tr><th>' + tag[1].group_name + '</th>' + ((tag[0] in link_info.tags && link_info.tags[tag[0]] !== null) ? '<td>' + data.fluxTags[tag[0]].tags[link_info.tags[tag[0]]].name + '</td></tr>' : '<td></td></tr>'));
        t += '</tbody></table>';
    }
    else {
        // Variables libres
        // let tmp 
        // if (link_info.display_value.includes('-')) {
        //   tmp = link_info.display_value.split('-')
        // } else if (link_info.display_value.includes(',')) {
        //   tmp = link_info.display_value.split(',')                
        // } else if (link_info.display_value.includes('...')) {
        //   tmp = link_info.display_value.split('...')           
        // } else {
        //   tmp = link_info.display_value.split('  ')          
        // }
        const mini = link_info.extension.free_mini;
        const maxi = link_info.extension.free_maxi;
        if (mini !== maxi) {
            t += '<table class="table table-striped " >';
            if (units_names && units_names[0]) {
                t += '<thead><tr><th></th>';
                t += '<th>' + default_unit_name.replace('tonnes', 't').replace('tonne', 't') + '</th>';
                if (l.conv) {
                    t += '<th>' + unit_coeff + String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't') + '</th>';
                }
                for (let i = 2; i < units_names.length; i++) {
                    if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                        continue;
                    }
                    if (l.conv && l.conv[i] !== null) {
                        t += '<th>' + unit_coeff + units_names[i][0].replace('tonnes', 't').replace('tonne', 't') + '</th>';
                    }
                }
                t += '</tr></thead>';
            }
            t += '<tbody><tr>';
            t += '<td>Intervalle</td><td>[' + SankeyUtils_1.toPrecision(mini) + '  ' + SankeyUtils_1.toPrecision(maxi) + ']' + '</td>';
            if (l.conv) {
                if (l.natural_unit) {
                    t += '<td>[' + SankeyUtils_1.toPrecision(mini * l.conv[1]) + '  ' + SankeyUtils_1.toPrecision(maxi * l.conv[1]) + ']' + '</td>';
                }
                for (let i = 2; i < units_names.length; i++) {
                    if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                        continue;
                    }
                    if (l.conv[i] !== null) {
                        t += '<td>[' + SankeyUtils_1.toPrecision(mini * l.conv[i]) + '  ' + SankeyUtils_1.toPrecision(maxi * l.conv[i]) + ']' + '</td>';
                    }
                }
            }
            t += '</tr></tbody></table>';
        }
        else {
            t += '<table class="table table-striped " >';
            if (units_names && units_names[0]) {
                t += '<thead><tr>';
                t += '<th>' + default_unit_name.replace('tonnes', 't').replace('tonne', 't') + '</th>';
                if (l.conv) {
                    t += '<th>' + unit_coeff + String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't') + '</th>';
                }
                for (let i = 2; i < units_names.length; i++) {
                    if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                        continue;
                    }
                    if (l.conv && l.conv[i] !== null) {
                        t += '<th>' + unit_coeff + units_names[i][0].replace('tonnes', 't').replace('tonne', 't') + '</th>';
                    }
                }
                t += '</tr></thead>';
            }
            t += '<tr><td>Valeur</td><td>' + mini + '</td>';
            if (l.conv) {
                t += '<td>' + SankeyUtils_1.toPrecision(mini * l.conv[1]) + '</td>';
                for (let i = 2; i < units_names.length; i++) {
                    if (units_names[i][0].replace('tonnes', 't').replace('tonne', 't') == String(l.natural_unit).replace('tonnes', 't').replace('tonne', 't')) {
                        continue;
                    }
                    if (l.conv[i] !== null) {
                        t += '<td>' + SankeyUtils_1.toPrecision(mini * l.conv[i]) + '</td>';
                    }
                }
            }
        }
        t += '</tr>';
        t += '</tbody></table>';
    }
    if (l.tooltips) {
        let title = false;
        const count = tooltip_names.filter((tooltip_name, i) => {
            return (l.tooltips && l.tooltips[i] !== undefined && l.tooltips[i] !== null);
        }).length;
        const width = 100 / count + 'px';
        tooltip_names.forEach((tooltip_name, i) => {
            if (l.tooltips && l.tooltips[i] !== undefined && l.tooltips[i] !== null) {
                if (title === false) {
                    t += '<p>Hypothèses</p>';
                    t += '<table class="table table-striped " >';
                    t += '<thead><tr>';
                    title = true;
                }
                t += '<th width="' + width + '">' + tooltip_name[0] + '</th>';
            }
        });
        t += '</tr></thead>';
        t += '<tr><tbody>';
        tooltip_names.forEach((_, i) => {
            if (l.tooltips && l.tooltips[i] !== undefined && l.tooltips[i] !== null) {
                if (typeof l.tooltips[i] === 'number') {
                    if (tooltip_names[i].includes('%')) {
                        t += '<td>' + SankeyUtils_1.toPrecision(Number(l.tooltips[i]) * 100) + '</td>';
                    }
                    else {
                        t += '<td>' + SankeyUtils_1.toPrecision(+l.tooltips[i]) + '</td>';
                    }
                }
                else {
                    t += '<td>' + l.tooltips[i] + '</td>';
                }
            }
        });
        t += '</tr></tbody></table>';
    }
    return t;
};
exports.linkTooltipsContent = linkTooltipsContent;
const nodeTooltipsContent = (data, n) => {
    const { units_names, nodes } = data;
    const display_links = data.links;
    let unit_coeff = ' ';
    if (units_names && units_names[0] && data.units_names[0].length > 0) {
        if (data.units_names[0][0].includes('k ')) {
            unit_coeff = ' k ';
        }
    }
    let t = '<p class="title" style="margin-bottom: 5px;">' + n.name.split('\\n').join(' ') + '</p>';
    t += '<div style="padding-left :5px;padding-right :5px">';
    if (n.tooltip_text) {
        //t += '<p><b>Définition'+ '</b></p>' 
        //t += '<p class="subtitle">'+n.tooltip_text.split('\n').join('</br>')+ '</p>' 
        t += '<p class="subtitle" style="	margin-bottom: 5px;">' + n.tooltip_text.split('\n').join('<br>') + '</p>';
    }
    let total = 0;
    let has_natural_unit = false;
    if (n.inputLinksId.length > 0) {
        for (let i = 0; i < n.inputLinksId.length; i++) {
            const link = display_links[n.inputLinksId[i]];
            if (link === undefined) {
                //alert('Corruption du diagramme')
                return '';
            }
            if (!SankeyUtils_1.link_visible(link, data, SankeyUtils_1.getLinkValue)) {
                continue;
            }
            const link_info = SankeyUtils_1.getLinkValue(data, link.idLink);
            let the_value = link_info.value;
            if ('display_value' in link_info && link_info.display_value !== '' && !link_info.display_value.includes('[')) {
                the_value = Number(String(link_info.display_value).replace('*', ''));
            }
            if (nodes[link.idSource].node_visible && nodes[link.idTarget].node_visible) {
                total += (the_value) ? the_value : 0;
                if (link.conv && link.natural_unit) {
                    has_natural_unit = true;
                }
            }
        }
    }
    //t += '<br>'
    if (n.inputLinksId.length > 0) {
        t += '<p class="tab-title" style="margin-bottom: 5px;">Entrées' + '</p>';
        t += '<table class="table" style="margin-bottom: 5px;">';
        t += '<thead><tr>';
        t += '<table class="table" style="margin-bottom: 5px;">';
        t += '<thead><tr>';
        if (units_names && units_names[0]) {
            if (has_natural_unit) {
                t += '<th width="150px"></th><th width="120px">Unités naturelles</th><th width="120px">Unité équivalente</th><th width="120px">Pourcentage</th>';
            }
            else {
                t += '<th width="150px"></th><th>' + units_names[0][0] + '</th><th width="120px">Pourcentage</th>';
            }
            //t +=      '<th width="150px"></th><th width="120px">Unités naturelles</th><th width="120px">Unité équivalente</th><th width="120px">Pourcentage</th>'
        }
        else {
            t += '<th width="150px"></th><th width="120px">Valeur</th><th width="120px">Pourcentage</th>';
        }
        Object.values(data.fluxTags).forEach(tag => t += '<th>' + tag.group_name + '</th>');
        t += '</tr></thead>';
        for (let i = 0; i < n.inputLinksId.length; i++) {
            const link = display_links[n.inputLinksId[i]];
            if (link === undefined) {
                //alert('Corruption du diagramme')
                return '';
            }
            const link_info = SankeyUtils_1.getLinkValue(data, link.idLink);
            let the_value = link_info.value;
            if (link_info.display_value == 'missing') {
                continue;
            }
            if (!SankeyUtils_1.link_visible(link, data, SankeyUtils_1.getLinkValue)) {
                continue;
            }
            if ('display_value' in link_info && link_info.display_value !== '' && !link_info.display_value.includes('[')) {
                the_value = Number(String(link_info.display_value).replace('*', ''));
            }
            if (nodes[link.idSource].node_visible && nodes[link.idTarget].node_visible) {
                const source_name = data.nodes[link.idSource].name.split('\\n').join(' ');
                t += '<tr><td>' + source_name + '</td>';
                if (link.conv && link.natural_unit) {
                    t += '<td>' + SankeyUtils_1.toPrecision(((the_value) ? the_value : 0) * link.conv[1]) + unit_coeff + link.natural_unit.replace('tonnes', 't').replace('tonne', 't') + '</td>';
                }
                else if (has_natural_unit && units_names && units_names[0]) {
                    t += '<td></td>';
                }
                t += '<td>' + SankeyUtils_1.toPrecision((the_value) ? the_value : 0);
                if (has_natural_unit && units_names && units_names[0]) {
                    t += ' ' + units_names[0][0];
                }
                if (n.inputLinksId.length > 0) {
                    const percent = Math.round(SankeyUtils_1.getLinkValue(data, link.idLink).value * 100 / total);
                    t += '</td><td>' + percent + '%</td>';
                    Object.keys(data.fluxTags).forEach(tag => t += (tag in link_info.tags && link_info.tags[tag] !== null) ? '<td>' + data.fluxTags[tag].tags[link_info.tags[tag]].name + '</td>' : '<td></td>');
                    t += '</tr>';
                }
                else {
                    t += '</td></tr>';
                }
            }
        }
        if (has_natural_unit && units_names && units_names[0]) {
            t += '<tr><th>Total</th><td></td><td>' + SankeyUtils_1.toPrecision(total) + ' ' + units_names[0][0] + '</td><td></td>';
        }
        else {
            t += '<tr><th>Total</th><td>' + SankeyUtils_1.toPrecision(total) + '</td><td></td>';
        }
        Object.keys(data.fluxTags).forEach(() => t += '<td></td>');
        t += '</tr></tbody></table>';
    }
    total = 0;
    if (n.outputLinksId.length > 0) {
        for (let i = 0; i < n.outputLinksId.length; i++) {
            const link = display_links[n.outputLinksId[i]];
            if (link === undefined) {
                //alert('Corruption du diagramme')
                return '';
            }
            if (!SankeyUtils_1.link_visible(link, data, SankeyUtils_1.getLinkValue)) {
                continue;
            }
            const link_info = SankeyUtils_1.getLinkValue(data, link.idLink);
            if (link_info.display_value == 'missing') {
                continue;
            }
            let the_value = link_info.value;
            if ('display_value' in link_info && link_info.display_value !== '' && !link_info.display_value.includes('[')) {
                the_value = Number(String(link_info.display_value).replace('*', ''));
            }
            if (nodes[link.idSource].node_visible && nodes[link.idTarget].node_visible) {
                total += (the_value) ? the_value : 0;
                if (link.conv && link.natural_unit) {
                    has_natural_unit = true;
                }
            }
        }
        if (n.outputLinksId.length > 0) {
            t += '<p class="tab-title" style="margin-bottom: 5px;">Sorties' + '</p>';
            t += '<table class="table" style="margin-bottom: 5px;">';
            t += '<thead><tr>';
            if (units_names && units_names[0]) {
                if (has_natural_unit) {
                    t += '<th width="150px"></th><th width="120px">Unités naturelles</th><th width="120px">Unité équivalente</th><th width="120px">Pourcentage</th>';
                }
                else {
                    t += '<th width="150px"></th><th>' + units_names[0][0] + '</th><th width="120px">Pourcentage</th>';
                }
                //t +=      '<th width="150px"></th><th width="120px">Unités naturelles</th><th width="120px">Unité équivalente</th><th width="120px">Pourcentage</th>'
            }
            else {
                t += '<th width="150px"></th><th width="120px">Valeur</th><th width="120px">Pourcentage</th>';
            }
            Object.values(data.fluxTags).forEach(tag => t += '<th>' + tag.group_name + '</th>');
            t += '</tr></thead>';
            for (let i = 0; i < n.outputLinksId.length; i++) {
                const link = data.links[n.outputLinksId[i]];
                if (link === undefined) {
                    //alert('Corruption du diagramme')
                    return '';
                }
                const link_info = SankeyUtils_1.getLinkValue(data, link.idLink);
                if (!SankeyUtils_1.link_visible(link, data, SankeyUtils_1.getLinkValue)) {
                    continue;
                }
                let the_value = link_info.value;
                if ('display_value' in link_info && link_info.display_value !== '' && !link_info.display_value.includes('[')) {
                    the_value = Number(String(link_info.display_value).replace('*', ''));
                }
                if (nodes[link.idSource].node_visible && nodes[link.idTarget].node_visible) {
                    const target_name = data.nodes[link.idTarget].name.split('\\n').join(' ');
                    t += '<tr><td>' + target_name + '</td>';
                    if (link.conv && link.natural_unit) {
                        t += '<td>' + SankeyUtils_1.toPrecision(((the_value) ? the_value : 0)) * link.conv[1] + unit_coeff + link.natural_unit.replace('tonnes', 't').replace('tonne', 't') + '</td>';
                    }
                    else if (has_natural_unit && units_names && units_names[0]) {
                        t += '<td></td>';
                    }
                    t += '<td>' + SankeyUtils_1.toPrecision((the_value) ? the_value : 0);
                    if (has_natural_unit && units_names && units_names[0]) {
                        t += ' ' + units_names[0][0];
                    }
                    if (n.outputLinksId.length >= 0) {
                        const percent = Math.round(SankeyUtils_1.getLinkValue(data, link.idLink).value * 100 / total);
                        t += '</td><td>' + percent + '%</td>';
                        Object.keys(data.fluxTags).forEach(tag => t += (tag in link_info.tags && link_info.tags[tag] !== null) ? '<td>' + data.fluxTags[tag].tags[link_info.tags[tag]].name + '</td>' : '<td></td>');
                        t += '</tr>';
                    }
                    else {
                        t += '</td></tr>';
                    }
                }
            }
        }
        if (has_natural_unit && units_names && units_names[0]) {
            t += '<tr><th>Total</th><td></td><td>' + SankeyUtils_1.toPrecision(total) + ' ' + units_names[0][0] + '</td><td></td>';
        }
        else {
            t += '<tr><th>Total</th><td>' + SankeyUtils_1.toPrecision(total) + '</td><td></td>';
        }
        Object.keys(data.fluxTags).forEach(() => t += '<td></td>');
        t += '</tr></tbody></table>';
    }
    if (!n.dimensions) {
        return t;
    }
    let header_written = false;
    Object.keys(n.dimensions).forEach(dim => {
        if (data.nodeTags[dim].activated === false) {
            return;
        }
        let has_parent = false;
        if (n.dimensions[dim].parent_name && data.nodes[n.dimensions[dim].parent_name]) {
            if (!header_written) {
                t += '<br><p><b>Noeuds parents et enfants<b></p>';
                t += '<table class="table table-striped " ><thead><tr><th width="50%">Noeuds parents</th><th width="50%">Noeuds enfants</th></tr></thead><tbody><tr>';
                header_written = true;
            }
            has_parent = true;
            t += '<td>' + data.nodes[n.dimensions[dim].parent_name].name + '</td>';
        }
        const desagregate_nodes = Object.values(data.nodes).filter(node => node.dimensions[dim] && node.dimensions[dim].parent_name === n.idNode);
        if (desagregate_nodes.length > 0) {
            if (!header_written) {
                t += '<br><p><b>Noeuds agrégés et désagrégés</b></p>';
                t += '<table class="table table-striped " ><thead><tr><th width="50%">Noeuds parents</th><th width="50%">Noeuds enfants</th></tr></thead><tbody><tr>';
                header_written = true;
            }
            if (!has_parent) {
                t += '<td></td>';
            }
            t += '<td>';
            desagregate_nodes.forEach(n => t += n.name + '<br>');
            t += '</td>';
        }
        else {
            t += '<td></td>';
        }
        t += '</tr>';
    });
    t += '</tbody></table>';
    t += '</div>';
    return t;
};
exports.nodeTooltipsContent = nodeTooltipsContent;
const set_animation_tooltips = (animation_tooltips) => {
    Object.keys(animation_tooltips).forEach(pos => {
        const svg = d3.select('#svg');
        const tooltip = svg.append('g')
            .attr('class', 'tooltip')
            .attr('id', 'main_tooltip' + pos);
        tooltip.append('rect')
            .attr('class', 'rect_tooltip')
            .attr('id', 'rect_main_tooltip' + pos)
            .attr('rx', 5)
            .attr('height', 50)
            .attr('width', 100);
        tooltip.append('text')
            .attr('class', 'text_tooltip')
            .attr('id', 'text_main_tooltip' + pos);
        // d3.select('#text_main_tooltip'+pos)
        //   .append('tspan')
        //   .attr('id','main_tooltip'+'span')
        //   .attr('x',10)
        //   .attr('dy',10)
        //   .attr('class','text_tooltip')
        //   .text(animation_tooltips[pos])
        let max_text_length = 0;
        const tooltip_lines = animation_tooltips[pos].split('\\n');
        let dy = '1em';
        tooltip_lines.forEach((e, r) => {
            let tooltip_class = 'text_tooltip';
            if (e.includes('<b>')) {
                e = e.substring(3);
                tooltip_class = 'text_tooltip_title';
            }
            if (e === '') {
                dy = '2em';
                return;
            }
            d3.select('#text_main_tooltip' + pos)
                .append('tspan')
                .attr('id', 'text_main_tooltip_span' + r)
                .attr('x', 10)
                .attr('dy', dy)
                .attr('class', tooltip_class)
                .text(e);
            dy = '1em';
            const tooltip_el = d3.select('#text_main_tooltip_span' + r).node();
            if (tooltip_el) {
                const text_length = tooltip_el.getComputedTextLength();
                if (text_length >= max_text_length) {
                    max_text_length = text_length;
                    //d3.select('#rect_tooltip_'+suffix+i)
                }
            }
        });
        if (tooltip_lines.length > 1 || tooltip_lines[0] !== '') {
            d3.select('#rect_main_tooltip' + pos)
                .attr('width', max_text_length + 80)
                .attr('height', () => {
                const tooltip_text = animation_tooltips[pos].split('<br>').join('\\n');
                const count_br = (tooltip_text.match(/\\n/g) || []).length;
                return Math.max(50, count_br * 20);
            });
        }
    });
};
exports.set_animation_tooltips = set_animation_tooltips;
function write_children_table(desagregate_source_nodes, desagregate_target_nodes, data, t, default_unit_name, l, is_data) {
    let header_written = false;
    desagregate_source_nodes.forEach(n1 => {
        desagregate_target_nodes.forEach(n2 => {
            const desagregated_link = Object.values(data.links).filter(l => l.idSource === n1.idNode && l.idTarget === n2.idNode)[0];
            if (desagregated_link === undefined) {
                return;
            }
            const desagregated_link_info = SankeyUtils_1.getLinkValue(data, desagregated_link.idLink);
            if (desagregated_link_info.extension.data_value) {
                if (!header_written) {
                    t += is_data ? '<p>Données collectées sur les flux désagrégés </p>' : '<p>Données réconciliées sur les flux désagrégés </p>';
                    t += '<table class="table table-striped " >';
                    t += '<thead><tr>';
                    t += '<th>Flux désagrégés</th>';
                    if (default_unit_name !== '') {
                        t += '<th>' + default_unit_name + '</th>';
                        t += '<th>Unité naturelle</th>';
                    }
                    else {
                        t += '<th>Valeur</th>';
                    }
                    if (is_data) {
                        t += '<th>Source</th>';
                        t += '<th>Période</th>';
                    }
                    t += '</tr></thead>';
                    t += '<tbody>';
                    header_written = true;
                }
                //const value_field = is_data ? 'data_value' : 'value'
                let value_to_display = is_data ? +desagregated_link_info.extension['data_value'] : +desagregated_link_info['value'];
                if (!is_data && desagregated_link_info.display_value && desagregated_link_info.display_value.includes('*')) {
                    value_to_display = +String(SankeyUtils_1.getLinkValue(data, desagregated_link.idLink).display_value).replace('*', '');
                }
                t += '<tr>';
                t += '<td>' + data.nodes[desagregated_link.idSource].name + '->' + data.nodes[desagregated_link.idTarget].name + '</td>';
                t += '<td>' + SankeyUtils_1.toPrecision(value_to_display) + '</td>';
                if (desagregated_link.conv) {
                    t += '<td>' + SankeyUtils_1.toPrecision(value_to_display * desagregated_link.conv[1]) + ' ' + desagregated_link.natural_unit + '</td>';
                }
                else if (l.conv) {
                    t += '<td>' + SankeyUtils_1.toPrecision(value_to_display * l.conv[1]) + ' ' + desagregated_link.natural_unit + '</td>';
                } //else {
                //   t += '<td></td>'
                // }
                if (is_data) {
                    if (desagregated_link_info.extension.data_source) {
                        t += '<td>' + desagregated_link_info.extension.data_source + '</td>';
                    }
                    else {
                        t += '<td></td>';
                    }
                    if (desagregated_link_info.extension.data_period) {
                        t += '<td>' + desagregated_link_info.extension.data_period + '</td>';
                    }
                    else {
                        t += '<td></td>';
                    }
                }
                t += '</tr>';
            }
        });
    });
    if (header_written) {
        t += '</tr></tbody></table>';
    }
    return t;
}
